import React, { ReactElement, useState } from "react";
import CardActions from '@mui/material/CardActions';
import CurrencyFieldEditor from '../../field/editors/currencyfieldeditor';
import QuestionBox from "../box";
import QuestionValue from "../value";
import { QuestionEditorProps, Value, CurrencyQuestionSpec } from '../../../types/types';
import QuestionEditorButton from "../questioneditorbutton";
import QuestionLabel from '../label';

function CurrencyQuestionEditor(props: QuestionEditorProps<CurrencyQuestionSpec>) : ReactElement {
  const [value, setValue] = useState<Value>(props.answer?.value);

  return (
    <QuestionBox>
      <QuestionLabel spec={props.spec} />
      <QuestionValue>
        <CurrencyFieldEditor value={props.answer?.value as string || undefined} setValue={setValue}/>
      </QuestionValue>
      <CardActions>
        <QuestionEditorButton response={value} setResponse={setValue} defaultValue={props.answer?.value} buttonsSettings={props.buttonsSettings} />
      </CardActions>
    </QuestionBox>
  );
}

export default CurrencyQuestionEditor;
